import React, { useState, useEffect } from 'react';
import CourseCardInstructor from './CourseCardInstructor';
import CourseBuilderForm from './CourseBuilderForm';
import { useAuth } from './AuthContext';
import api from '../api';

const CourseListInstructor = ({ onEditCourse, onViewStats }) => {
  const { currentUser } = useAuth();
  const [courses, setCourses] = useState([]);
  const [showNewCourseForm, setShowNewCourseForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchInstructorCourses = async () => {
      if (!currentUser?.id) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError('');

      try {
        const response = await api.get(`/courses/instructor/${currentUser.id}`);
        setCourses(Array.isArray(response.data?.data) ? response.data.data : []);
      } catch (err) {
        console.error('Error al obtener cursos:', err);
        if (err.response?.status === 404) {
          setError('No se encontraron cursos o la ruta es incorrecta');
        } else {
          setError('Error al cargar los cursos');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchInstructorCourses();
  }, [currentUser]);

  const handleCreateCourse = () => {
    setShowNewCourseForm(true);
  };

  const handleSaveNewCourse = (newCourse) => {
    setCourses((prevCourses) => [...prevCourses, newCourse]);
    setShowNewCourseForm(false);
  };

  const handleCancelNewCourse = () => {
    setShowNewCourseForm(false);
  };

  if (loading) {
    return <div className="text-center py-8">Cargando cursos...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Mis cursos</h2>
        <button
          onClick={handleCreateCourse}
          className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          disabled={showNewCourseForm}
        >
          + Crear nuevo curso
        </button>
      </div>

      {showNewCourseForm ? (
        <CourseBuilderForm
          onSave={handleSaveNewCourse}
          onCancel={handleCancelNewCourse}
        />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.length > 0 ? (
            courses.map((course) => (
              <CourseCardInstructor
                key={course.id}
                course={course}
                onEdit={onEditCourse}
                onViewStats={onViewStats}
              />
            ))
          ) : (
            <div className="col-span-full text-center py-12 bg-white rounded-lg shadow-sm">
              <p className="text-gray-600 mb-4">No tienes cursos creados aun.</p>
              <button
                onClick={handleCreateCourse}
                className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
              >
                Crear tu primer curso
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CourseListInstructor;
